import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from '../../../../../services/language.service';
import { Offer } from '../../../../../../core/models/offer/offer.model';
import {OfferCoverageCode} from '../../../../../../core/consts/offer-coverages/offer-coverage-code.enum';
import {OfferCoverageDestinyCode} from '../../../../../../core/enums/offer/offer-coverage-destiny-code.enum';

@Component({
  selector: 'app-offer-car-valuation',
  templateUrl: './offer-car-valuation.component.html',
  styleUrls: ['./offer-car-valuation.component.scss']
})
export class OfferCarValuationComponent implements OnInit {
  static readonly valuationCoverageCode = OfferCoverageCode.AC_VALUE_OF_VEHICLE;

  @Input() offer: Offer;
  @Input() columnPosition: boolean = false;
  @Input() addValuationColorStyles: boolean = false;
  @Input() valuationTranslation: string = 'OFFER_SECTION.BOX.carValuation';

  carValuation: number;

  constructor(private language: LanguageService) { }

  ngOnInit() {
    this.setCarValuation();
  }

  private setCarValuation() {
    const offerCoverage = this.offer.coverages.filter(coverage => coverage.code === OfferCarValuationComponent.valuationCoverageCode)[0];
    const coverageDestiny = offerCoverage.destinies.filter(destiny => destiny.code === OfferCoverageDestinyCode.DETAIL_BOX)[0];
    const selectedOption = coverageDestiny.options.filter(option => option.code === coverageDestiny.selectedOption)[0];

    if (selectedOption.type === 'STRING' || selectedOption.type === 'NUMBER') {
      this.carValuation = Number.parseInt(this.language.getTranslationForKey(selectedOption.values, 'value'));
    } else if (selectedOption.type === 'BOOLEAN') {
      const value = this.language.getTranslationForKey(selectedOption.values, 'value');
      if (!value) {
        this.carValuation = null;
      }
    } else {
        this.carValuation = null;
    }
  }


}
